import { useCallback, useEffect, useState } from "react";
import { MeterDataType } from "../../interfaces/MeterType";
import useAppStore from "../../store/AppStore";
import Chart from "./Chart";
import styles from "./Chart.module.css";

export default function ChartContainer({ data }: { data: MeterDataType }) {
  const { isDeviceMobile } = useAppStore();
  const [isScrolled, setIsScrolled] = useState(false);

  let id = "chartContainer";

  const handleScroll = useCallback(() => {
    const parentElement = document.getElementById(id);
    if (parentElement) {
      const parentHeight = parentElement.clientHeight;
      const scrollThreshold = parentHeight * (isDeviceMobile ? 2.7 : 2.2); // Adjust as needed
      const currentScroll = window.scrollY;
      setIsScrolled(currentScroll > scrollThreshold);
    }
  }, [isDeviceMobile]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  const getHeight = () => {
    if (!isDeviceMobile && !isScrolled) {
      return "230px";
    }
    if (!isDeviceMobile && isScrolled) {
      return "170px";
    }
    if (isDeviceMobile && !isScrolled) {
      return "135px";
    }
    return "110px";
  };

  return (
    <div
      id={id}
      className={`vas-bg-white vas-w-100 ${
        isScrolled && styles.bottom_shadow
      } ${styles.chart_parent}`}
      style={{
        top: !isDeviceMobile ? "0px" : "-10px",
        height: getHeight(),
      }}
    >
      <div
        style={{
          background: "transparent",
        }}
        className={`vas-h-100 vas-w-100 vas-d-flex vas-justify-content-center ${
          isScrolled ? styles.scrolled : styles.reverse_scroll
        }`}
        dir="ltr"
      >
        <Chart data={data} />
      </div>
    </div>
  );
}
